import {DropdownItem, useSetAndCacheFilter} from '@eitje/web_components'

export const EnvironmentDropdownItem = ({ids, icon = 'external-link'}) => {
	const applyEnvironmentFilter = useSetAndCacheFilter({
		name: 'environments_filters',
		filterName: 'environment',
	})
	return (
		<DropdownItem
			iconLeft={icon}
			t={ids.length === 1 ? 'environments.show_environment' : 'environments.show_environments'}
			onClick={() => applyEnvironmentFilter(ids)}
			to="/firms/environments"
		/>
	)
}

export const OrganisationDropdownItem = ({id, icon = 'external-link'}) => {
	const applyOrganisationsFilter = useSetAndCacheFilter({
		name: 'organisations_filters',
		filterName: 'organisation',
	})
	return (
		<DropdownItem
			iconLeft={icon}
			t="organisations.show_organisation"
			onClick={() => applyOrganisationsFilter([id])}
			to="/firms/organisations"
		/>
	)
}

export const BillingInfoDropdownItem = ({id, icon = 'external-link'}) => {
	return <DropdownItem iconLeft={icon} t="billing_infos.show_billing_info" to={`/billing/billing_infos/${id}`} disabled={!id} />
}
